import React from "react";
const ErrorPage = () => React.createElement("p", null, "Something went wrong");
export default ErrorPage;
